import { stylesIf, themeColor } from 'utils/styles'
import styled from '@emotion/styled'
import { ScrollButton } from 'components/PanZoomToolbar/PanZoomToolbar.style'
import { MODULE_LAYOUT_SIZE, GAP_MIN } from './constants'

export const VehicleSummaryPane = styled.div``

export const ModulesContainer = styled.div((props) => {
  const { asSlider, expanded } = props

  if (asSlider) {
    return `
      display: block;
      width: 100%;
      margin: 16px 0;
      position: relative;
    `
  }

  return `
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 16px 0;
    align-items: stretch;
    ${stylesIf(
      expanded,
      `
      flex-wrap: wrap;
      gap: 12px;
      width: 'auto';
      margin: 16px auto;
    `
    )}
  `
})

export const ModulesScrollWrapper = styled.div((props) => {
  const { width, cardSize, cardIndex, asSlider, numberOfModules } = props
  const padding = 2
  const sidePadding = numberOfModules < 3 ? 20 : 10
  return `
    display: flex;
    flex-direction: row;
    justify-content: ${numberOfModules <= 2 ? `center` : `space-between`};
    padding: ${asSlider ? `${padding}px` : `${padding}px ${sidePadding}px`};
    width: ${width}px;
    gap: 12px;
    ${stylesIf(asSlider, `transition: ease 500ms;`)}
    ${stylesIf(
      asSlider && cardIndex > 1,
      `
      transform: translate3d(-${
        (cardIndex - 1) * MODULE_LAYOUT_SIZE[cardSize] +
        (GAP_MIN * cardIndex - 1) -
        padding * 2
      }px, 0, 0);
    `
    )}
`
})

export const ModuleCard = styled.div((props) => {
  const { size, selected, flexible } = props

  const width = MODULE_LAYOUT_SIZE[size]
  return `
    display: flex;
    width: ${width}px;
    color: white;
    justify-content: center;
    align-items: flex-start;
    border-radius: 8px;
    box-shadow: 0 0.8px 4.1px 0 ${themeColor('blackPrimaryShadow', props)};
    background-color: ${themeColor('whitePrimary', props)};
    cursor: pointer;
    padding: 16px;

    ${stylesIf(
      selected,
      `border: 1px solid ${themeColor('blueAccent', props)};`
    )}
    
    ${stylesIf(
      flexible,
      `
      padding: 16px 20px;
    `
    )}
    &:hover {
      background-color: ${themeColor('blueLight', props)};
    }
  `
})

export const Controls = styled.div`
  ${ScrollButton} {
    position: absolute;
    top: 40%;
  }
  ${ScrollButton}:first-of-type {
    left: 1px;
  }
  ${ScrollButton}:last-of-type {
    right: 3px;
  }
`
